module.exports = __webpack_public_path__ + "img/go-to.a5f7d890.png";